import React from 'react'
import PropTypes from 'prop-types'

import './badge.pcss'

const Badge = ({ count, children }) => {
    if (!count && children) return children

    return (
        <div className="badge-wrapper">
            <div className="badge__content">{children}</div>
            {count ? (
                <div className="badge">
                    <span className="badge__count">{count}</span>
                </div>
            ) : null}
        </div>
    )
}

Badge.propTypes = {
    count: PropTypes.number.isRequired
}

export default Badge
